import axiosInstance from '../axios.config';
import { Product } from '../../integrations/woocommerce/types';

const WISHLIST_ENDPOINT = '/nex/v1/wishlist';

// Updated: headers structure correctly for axios
const getWishlistConfig = (token: string) => ({
  headers: { 
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  },
  withCredentials: true 
});

export const fetchWishlistFromServer = async (token: string): Promise<Product[]> => {
  if (!token || token === 'null') return [];
  try {
    const response = await axiosInstance.get(WISHLIST_ENDPOINT, getWishlistConfig(token));
    return Array.isArray(response.data?.items) ? response.data.items : [];
  } catch (error) {
    console.error('Fetch Error:', error);
    return [];
  }
};

export const addWishlistItemOnServer = async (product: Product, token: string): Promise<Product[]> => {
  try {
    
    const response = await axiosInstance.post(
      WISHLIST_ENDPOINT, 
      { product: { id: product.id } }, 
      getWishlistConfig(token)
    );
    return Array.isArray(response.data?.items) ? response.data.items : await fetchWishlistFromServer(token);
  } catch (error) {
    console.error('Add Error:', error);
    throw error;
  }
};

export const removeWishlistItemOnServer = async (productId: number, token: string): Promise<Product[]> => {
  try {
    const response = await axiosInstance.delete(
      `${WISHLIST_ENDPOINT}?product_id=${productId}`, 
      getWishlistConfig(token)
    );
    return Array.isArray(response.data?.items) ? response.data.items : await fetchWishlistFromServer(token);
  } catch (error) {
    console.error('Remove Error:', error);
    throw error;
  }
};